import script from "./AssetLibraryDialog.vue?vue&type=script&setup=true&lang=js"
export * from "./AssetLibraryDialog.vue?vue&type=script&setup=true&lang=js"

import "./AssetLibraryDialog.vue?vue&type=style&index=0&id=0ee0f014&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-0ee0f014"]])

export default __exports__